import { DOCUMENT } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ModalService } from '@app/services/modal/modal.service';
import { MsalAuthService } from '@app/services/msal-auth/msal-auth.service';
import { AppStore } from '@app/stores/app/app.store';

@Component({
    selector: 'app-page-header',
    imports: [MatTooltipModule],
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class PageHeaderComponent {
    private document = inject(DOCUMENT).defaultView?.document;
    private appStore = inject(AppStore);
    translate = this.appStore.i18n;
    isMF = this.appStore.isMF;
    msalAuthService = inject(MsalAuthService);
    modalService = inject(ModalService);

    userDetails = computed(() => {
        const fullName = this.msalAuthService.getUserFullName();
        const email = this.msalAuthService.getUserEmail();
        return `${fullName} (${email})`;
    });

    userFullNameInitials = computed(() => {
        const name = this.msalAuthService.getUserFullName();
        const words = name.split(' ');
        return words.length > 1
            ? words[0].charAt(0) + words[1].charAt(0)
            : words[0].charAt(0);
    });

    onConfirmClicked() {
        if (!this.document) return;

        this.document.cookie.split(';').forEach((cookie) => {
            const cookieName = cookie.split('=')[0].trim();
            if (!this.document) return;
            this.document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        });

        this.appStore.clearStorage();
        this.msalAuthService.logout();
    }
    onLogoutClicked(e: Event) {
        e.preventDefault();

        const { MESSAGE__AreYouSureYouWantToLogout, Confirm } = this.translate();
        void this.modalService
            .confirm({
                title: Confirm,
                message: MESSAGE__AreYouSureYouWantToLogout,
                confirmButton: { displayText: '', class: '!bg-ul-red-400 text-white!' },
                closeButton: { displayText: 'Close', class: '' },
                testId: 'rcp-logout',
            })
            .afterClosed()
            .subscribe((result) => {
                if (result) {
                    this.onConfirmClicked();
                }
            });
    }
}
